$("#ShopList > li").hide();
$("#ShopDetail > li").hide();

$("#ShopCityList li").click(function () {

    var ShopListCityID = $(this).find('a').attr("data-cityid");

    $("#ShopCityList li").removeClass("active");

    $(this).addClass("active");


    $("#ShopList > li").hide();
    $("#ShopList > li").each(function () {

        if ($(this).find('a').attr("data-cityid") == ShopListCityID) {
            $(this).slideDown('normal');
        }
    });

});

$("#ShopList li").click(function () {

    var ShopID = $(this).find('a').attr("data-id");
    $("#ShopList li").removeClass("active");
    $(this).addClass("active");

    $("#ShopDetail > li").hide();
    $("#ShopDetail > li").each(function () {

        if ($(this).attr("data-id") == ShopID) {
            $(this).slideDown('normal');
        }
    });

});

//function FilterSelect() {

//    $('a.StoreType').click(function () {

//        var storeType = $(this).attr("store_type");

//        console.log(storeType);

//        $.ajax({
//            type: 'GET',
//            url: "/Stores/StoreFilter",
//            data: 'WhichStore=' + storeType,
//            async: false,
//            cache: false,
//            success: function (data) {

//                if (data != null) {

//                    $("select.CityCountry option:not(:first)").remove();

//                    $.each(data.Result, function (i, val) {
//                        $('select.CityCountry').append(
//                        $("<option></option>")
//                          .attr("value", val.ID)
//                          .text(val.Name));
//                    });
//                }
//            },
//            error: function () {
//                alert('Lütfen tekrar deneyiniz.')
//            }

//        });
//        return false;

//    });

//};

//function SelectCities() {

//    $('#CityID').off('change').on('change', function () {

//        var cityName = $(this).val();
//        console.log(cityName);

//        $.ajax({
//            type: 'GET',
//            url: "/Stores/Index",
//            data: 'CityName=' + cityName,
//            async: false,
//            cache: false,
//            success: function (data) {
//                if (data != null) {

//                    console.log(data);

//                    $("#StoreContent").html("");

//                    $.each(data, function (i, val) {

//                        $('#StoreContent').append('<div class="col-xs-24 col-sm-12 col-md-8 col-lg-6"><div class="BoxStyle"><div class="StoreBox"><span>' + val.StoreType + '</span><br /><span style="font-size:13px;"><b>' + val.Name + '</b></span><br /><p>Adres: ' + val.Detail + '</p><span>' + val.CityName + '</span><br /><span>Telefon: ' + val.Phone + '</span></div></div></div>');

//                    });
//                }
//            },
//            error: function () {
//                alert('İsteğiniz yerine getirilirken bir hata oluştu.')
//            }

//        });
//        return false;

//    });

//}


//$(document).ready(function () {
//    initmap();
//    //SelectCities();
//});